var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indicator",class:{'active':_vm.mounted}},[_c('label',{staticClass:"indicator-text"},[_vm._v(_vm._s(_vm._f("translate")(_vm.title)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }